var map = {
	"./1.jpeg": 9462,
	"./10.jpeg": 3086,
	"./11.jpeg": 8495,
	"./12.jpeg": 1542,
	"./13.jpeg": 6350,
	"./14.jpeg": 7117,
	"./15.jpeg": 510,
	"./16.jpeg": 2304,
	"./17.jpeg": 4921,
	"./18.jpeg": 5226,
	"./19.jpeg": 9092,
	"./2.jpeg": 9496,
	"./20.jpeg": 9608,
	"./21.gif": 5013,
	"./22.gif": 6797,
	"./23.gif": 3860,
	"./24.png": 6703,
	"./26.gif": 811,
	"./27.png": 7810,
	"./28.png": 6284,
	"./29.png": 7617,
	"./3.jpeg": 9244,
	"./30.png": 2619,
	"./31.png": 421,
	"./4.jpeg": 4524,
	"./5.jpeg": 5089,
	"./6.jpeg": 6567,
	"./7.jpeg": 2591,
	"./8.jpeg": 2411,
	"./9.jpeg": 7263,
	"./Espresso.png": 2361,
	"./arxiv-alt.png": 8601,
	"./arxiv-main.png": 5974,
	"./cv-alt.png": 7280,
	"./cv-main.png": 3266,
	"./email-alt.png": 4489,
	"./email-main.png": 6145,
	"./google-scholar-alt.png": 1140,
	"./google-scholar-main.png": 2924,
	"./house.svg": 2959,
	"./icons.psd": 2918,
	"./minus-alt.png": 8641,
	"./minus-main.png": 6439,
	"./paper-alt.png": 2974,
	"./paper-main.png": 5087,
	"./plus-alt.png": 7495,
	"./plus-main.png": 5681,
	"./poster-alt.png": 1018,
	"./poster-main.png": 1328,
	"./profile-alt-original.png": 2093,
	"./profile-alt.png": 4328,
	"./profile-old.jpg": 3108,
	"./profile-zoom-out.jpg": 9050,
	"./profile.jpg": 7806,
	"./slides-alt.png": 4390,
	"./slides-main.png": 4975,
	"./video-alt.png": 5605,
	"./video-main.png": 3749,
	"./web-alt.png": 1093,
	"./web-main.png": 4889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;